import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function ReviewsSwiper() {

  const sections = document.querySelectorAll('.component-reviews');

  if ( !sections.length ) return;
  sections.forEach(section => {
    const container = section.querySelector('.reviews-swiper');
    const nextEl = section.querySelector('.swiper-button-next');
    const prevEl = section.querySelector('.swiper-button-prev');
    const paginationEl = section.querySelector('.swiper-pagination');
    const swiper = new Swiper(container, {
      modules: [Navigation, Pagination],
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable:true
      },
      on: {
        init: () => {
        }
      },
      breakpoints: {
        778: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        }
      }
    });


  })
}
